module.exports = __webpack_public_path__ + "img/logo_horizontal.e173bfe.svg";